import { createReactComponent } from "@market/react";
import { useMemo } from "react";
import { getMarketPrefix } from "../../config.js";
const useNamespacedMarketComponents = () => useMemo(() => {
  const prefix = getMarketPrefix();
  const MarketFilter = createReactComponent(`${prefix}market-filter`);
  const MarketActivityIndicator = createReactComponent(`${prefix}market-activity-indicator`);
  const MarketInputSearch = createReactComponent(`${prefix}market-input-search`);
  const MarketList = createReactComponent(`${prefix}market-list`);
  const MarketCheckbox = createReactComponent(`${prefix}market-checkbox`);
  const MarketRow = createReactComponent(
    `${prefix}market-row`
  );
  const MarketFilterButton = createReactComponent(`${prefix}market-filter-button`);
  const MarketButton = createReactComponent(`${prefix}market-button`);
  const MarketDropdown = createReactComponent(`${prefix}market-dropdown`);
  const MarketPopover = createReactComponent(`${prefix}market-popover`);
  const MarketLink = createReactComponent(`${prefix}market-link`);
  const MarketBlade = createReactComponent(`${prefix}market-blade`);
  const MarketHeader = createReactComponent(`${prefix}market-header`);
  const MarketToaster = createReactComponent(`${prefix}market-toaster`);
  const MarketSelect = createReactComponent(`${prefix}market-select`);
  const MarketRadio = createReactComponent(`${prefix}market-radio`);
  const MarketAccessory = createReactComponent(`${prefix}market-accessory`);
  const MarketField = createReactComponent(`${prefix}market-field`);
  const MarketInputText = createReactComponent(`${prefix}market-input-text`);
  return {
    MarketActivityIndicator,
    MarketButton,
    MarketCheckbox,
    MarketDropdown,
    MarketFilter,
    MarketFilterButton,
    MarketInputSearch,
    MarketLink,
    MarketList,
    MarketPopover,
    MarketRow,
    MarketBlade,
    MarketHeader,
    MarketToaster,
    MarketSelect,
    MarketRadio,
    MarketAccessory,
    MarketField,
    MarketInputText
  };
}, []);
export {
  useNamespacedMarketComponents
};
//# sourceMappingURL=index.js.map
